export function resolveUrl(path: string): string {
	const baseUrl = (import.meta as any).env.VITE_API_BASE_URL || '';
	if (path.startsWith('http') || path.startsWith('https') || path.startsWith('blob')) {
		return path;
	}
	return `${baseUrl}${path}`;
}
